import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { WidgetTypes } from 'types'
import { DEFAULT_TITLE_FONT_SIZE, FEATURE_NAME, IState } from '../Init.model'

const initialState: IState = {
  widgetType: null,
  title: null,
  titleFontSize: DEFAULT_TITLE_FONT_SIZE,
  seeAllScoresButton: true,
  backgroundImage: null,
}

export const initSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {
    setWidgetType(state, action: PayloadAction<WidgetTypes | null>) {
      state.widgetType = action.payload
    },
    setWidgetTitle(state, action: PayloadAction<string | null>) {
      state.title = action.payload
    },
    setWidgetTitleFontSize(state, action: PayloadAction<number>) {
      state.titleFontSize = action.payload
    },
    setSeeAllScoresButton(state, action: PayloadAction<boolean>) {
      state.seeAllScoresButton = action.payload
    },
    setBackgroundImage(state, action: PayloadAction<string | null>) {
      state.backgroundImage = action.payload
    },
  },
})

export const {
  setWidgetType,
  setWidgetTitle,
  setWidgetTitleFontSize,
  setSeeAllScoresButton,
  setBackgroundImage,
} = initSlice.actions
